import {
	COSMOS_DEFAULT_PROJECTS_ROUTE,
	COSMOS_DEFAULT_PROJECTS_ROUTE_PREFIX,
} from '@shared/constants/pages';

export const getDefaultProjectView = (options: string[], value: string) => {
	return options.includes(value)
		? `${COSMOS_DEFAULT_PROJECTS_ROUTE_PREFIX}/${value}`
		: COSMOS_DEFAULT_PROJECTS_ROUTE;
};
